export default {
  current: state => state.current
};
